export function isNum(v: string) {
  return /\d/.test(v);
}
